<div class="bottom-tray-container"
     [ngClass]="{ 'ms-bgc-w': (isDarkMode | async) }"
     role="navigation">
    <button *ngFor="let tab of tabs; trackBy: trackByTabId"
            [id]="'bottom-tray-tab-' + tab.id"
            (click)="navigateTo(tab)"
            class="bottom-tray__tab-button ms-fcl-nd"
            [ngClass]="{ 'ms-fcl-tp': tab.id === (activeTabId | async) }">
        <ohp-icon-font [iconFontName]="tab.iconClass" size="16"></ohp-icon-font>
        <div>{{ tab.title }}</div>
    </button>
</div>
